import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Tabs, Tab } from 'react-bootstrap';

// Helpers de formulário
import PaymentOrdersCheckTab from './PaymentOrdersCheckTab';
import PaymentOrdersDailyInternationalTab from './PaymentOrdersDailyInternationalTab';
import PaymentOrdersChiefBaseTab from './PaymentOrdersChiefBaseTab';
import PaymentOrdersDistanceTab from './PaymentOrdersDistanceTab';
import PaymentOrdersTransportTab from './PaymentOrdersTransportTab';
import getLocale from '../../../i18n/getLocale';

class PaymentOrdersScheduleTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
    };

    this.locale = getLocale();

  }

  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  render() {
    var self = this;
    return (
<div>
  <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
    <Tab eventKey={1} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabIndenizacoes.tabCheques}>
      <PaymentOrdersCheckTab RequestApi={this.props.request_api} refreshChecks={this.props.refreshChecks}  handleAlert={this.props.handleAlert} payment_order_id={this.props.payment_order_id} payment_order_payments_checks={this.props.payment_order_payments_checks} payment_order_data={this.props.payment_order_data} />
    </Tab>
    <Tab eventKey={2} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabIndenizacoes.tabRepresentanteOperacional}>
      <PaymentOrdersChiefBaseTab RequestApi={this.props.request_api} refreshChiefs={this.props.refreshChiefs}  handleAlert={this.props.handleAlert} payment_order_id={this.props.payment_order_id} payment_order_payments_base_chiefs={this.props.payment_order_payments_base_chiefs} payment_order_data={this.props.payment_order_data} />
    </Tab>
    <Tab eventKey={3} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabIndenizacoes.tabDeslocamento}>
      <PaymentOrdersDistanceTab RequestApi={this.props.request_api} refreshDeslocation={this.props.refreshDeslocation}  handleAlert={this.props.handleAlert} payment_order_id={this.props.payment_order_id} payment_order_payments_distance={this.props.payment_order_payments_distance} payment_order_data={this.props.payment_order_data} />
    </Tab>
    <Tab eventKey={4} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabIndenizacoes.tabTransporte}>
      <PaymentOrdersTransportTab RequestApi={this.props.request_api} refreshTransport={this.props.refreshTransport}  handleAlert={this.props.handleAlert} payment_order_id={this.props.payment_order_id} payment_order_payments_transport={this.props.payment_order_payments_transport} payment_order_data={this.props.payment_order_data} />
    </Tab>
  </Tabs>
</div>
    );
  }
}

export default PaymentOrdersScheduleTab;



// WEBPACK FOOTER //
// ./src/Components/PaymentOrders/Elements/PaymentOrdersRestitutionTab.js